import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { DailyRewardHeader } from "../DailyRewardHeader";
import { useStyles } from "./YourRewardCard.style";
import { useTranslation } from "react-i18next";

interface IYourRewardCardProps {
  coinReward: number;
}

export const YourRewardCard: FC<
  HTMLAttributes<HTMLDivElement> & IYourRewardCardProps
> = (props) => {
  const classes = useStyles();
  const { coinReward, className, ...otherProps } = props;
  const { t } = useTranslation();
  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <Typography variant={TypographyVariant.BodyB5Medium}>
        {t("common_Your Rewards")}
      </Typography>
      <DailyRewardHeader
        className={classes.wallets}
        sizeCoin={32}
        sizeTypo={TypographyVariant.HeadingH3Bold}
        idCoin="coin-start"
        nbCoin={coinReward}
        coinAdd={coinReward}
      />
    </div>
  );
};
